<p-dialog [ngClass]="'detalle-transaccion'" [(visible)]="showDialog" [modal]="true" [closable]="false"
  [resizable]="false">
  <ng-template pTemplate="header">
    <h5 class="display-3 tax-app-modal__header-title" style="color: #fff;">
      Detalles de la transacción
    </h5>
    <button pButton class="tax-app-button tax-app-button--clear tax-app-modal__header-button"
      (click)="showDialog=false">
      <i style="color: #fff; font-size: 1.4rem;" class="icon-taxes-close tax-app-button--icon-right"></i>
    </button>
  </ng-template>
  <div class="grid">
    <div class="col-12 md:col-4 flex flex-column justify-content-center  align-items-center">
      <img class="logo-pse-estado" [src]="'assets/img/pse.png'" alt="tag">
      <div class="flex flex-column">
        <div class="mt-4 flex flex-column">
          <p class="title__blue-light m-0 text-center">Impuesto</p>
          <p *ngIf="!isLoading" class="title__black m-0 mt-1 text-center">{{data?.impuesto}}</p>
          <p-skeleton width="7rem" *ngIf="isLoading" class="mt-1 align-self-center" height="1rem"
            borderRadius="16px"></p-skeleton>
        </div>
        <div class="mt-4 flex flex-column">
          <p class="title__blue-light m-0 text-center">Identificación</p>
          <p class="title__black m-0 mt-1 text-center" *ngIf="!isLoading">{{data?.idPersona}}</p>
          <p-skeleton width="7rem" *ngIf="isLoading" class="mt-1 align-self-center" height="1rem"
            borderRadius="16px"></p-skeleton>
        </div>
        <div class="mt-4 flex flex-column">
          <p class="title__blue-light m-0 text-center">Razón social</p>
          <p class="title__black m-0 mt-1 text-center" *ngIf="!isLoading">{{data?.razonSocial}}</p>
          <p-skeleton width="9rem" *ngIf="isLoading" class="mt-1 align-self-center" height="1rem"
            borderRadius="16px"></p-skeleton>
        </div>
        <div class="mt-4 flex flex-column">
          <p class="title__blue-light m-0 text-center">Fecha de proceso</p>
          <p class="title__black m-0 mt-1 text-center" *ngIf="!isLoading">{{data?.fechaTransaccion | date:'yyyy-MM-dd'}}</p>
          <p-skeleton width="8rem" *ngIf="isLoading" class="mt-1 align-self-center" height="1rem"
            borderRadius="16px"></p-skeleton>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-4 flex flex-column justify-content-center  align-items-left">
      <h3 class="text-center">Informacion de pago</h3>
      <div class="mt-4 flex flex-column">
        <p class="title__blue-light m-0 text-center md:text-left">Estado</p>
        <p class="title__black m-0 mt-1 text-center md:text-left" *ngIf="!isLoading">{{data?.estado}}</p>
        <p-skeleton width="5rem" *ngIf="isLoading" class="mt-1" height="1rem"
          borderRadius="16px"></p-skeleton>
      </div>
      <div class="mt-4 flex flex-column">
        <p class="title__blue-light m-0 text-center md:text-left">Número de la transacción</p>
        <p class="title__black m-0 mt-1 text-center md:text-left" *ngIf="!isLoading">{{data?.numeroDeTrans}}</p>
        <p-skeleton width="7rem" *ngIf="isLoading" class=" mt-1" height="1rem"
          borderRadius="16px"></p-skeleton>
      </div>
      <div class="mt-4 flex flex-column">
        <p class="title__blue-light m-0 text-center md:text-left">Código del servicio</p>
        <p class="title__black m-0 mt-1 text-center md:text-left" *ngIf="!isLoading">{{data?.codigoDeServicio}}</p>
        <p-skeleton width="7rem" *ngIf="isLoading" class="mt-1" height="1rem"
          borderRadius="16px"></p-skeleton>
      </div>
      <div class="mt-4 flex flex-column">
        <p class="title__blue-light m-0 text-center md:text-left">Valor total pagado</p>
        <p class="title__black m-0 mt-1 text-center md:text-left" *ngIf="!isLoading"> {{ data?.valorPagado | currency: data?.currency :'symbol-narrow':'1.0-0' }}</p>
        <p-skeleton width="8rem" *ngIf="isLoading" class="mt-1" height="1rem"
          borderRadius="16px"></p-skeleton>
      </div>
      <div class="mt-4 flex flex-column">
        <p class="title__blue-light m-0 text-center md:text-left">Entidad bancaria</p>
        <p class="title__black m-0 mt-1 text-center md:text-left" *ngIf="!isLoading">{{ data?.nombreBanco }}</p>
        <p-skeleton width="9rem" *ngIf="isLoading" class="mt-1" height="1rem"
          borderRadius="16px"></p-skeleton>
      </div>
      <div class="mt-4 flex flex-column">
        <p class="title__blue-light m-0 text-center md:text-left">No Confirmación entidad</p>
        <p class="title__black m-0 mt-1 text-center md:text-left" *ngIf="!isLoading">{{data?.trazabilitycode}}
        </p>
        <p-skeleton width="6rem" *ngIf="isLoading" class=" mt-1" height="1rem"
          borderRadius="16px"></p-skeleton>
      </div>
      <div class="mt-4 flex flex-column">
        <p class="title__blue-light m-0 text-center md:text-left">Referencia del pago</p>
        <p class="title__black m-0 mt-1 text-center md:text-left" *ngIf="!isLoading">{{data?.idTrans}}
        </p>
        <p-skeleton width="6rem" *ngIf="isLoading" class=" mt-1" height="1rem"
          borderRadius="16px"></p-skeleton>
      </div>
    </div>
    <div class="col-12 md:col-4 flex justify-content-center align-items-center">      
        <img class="logo-sm-detalle-pse" [src]="'assets/img/svg/logo-gob-institucional.png'" alt="tag">      
    </div>
  </div>
</p-dialog>